import src from "IMAGE";
export default { src, width: 240, height: 180, blurDataURL: "data:image/webp;base64,UklGRmEAAABXRUJQVlA4TFUAAAAvB0ABAM1VICICHghACgMAAIDDDADQaAgBIAAAJgAFAAAAAAAAAAAAGEEAAgAAQAAQAQAINivwBwMAICJS8HvaeLnAXnK6KyjbN48T1JcP0YDK0e4gAA==", blurWidth: 8, blurHeight: 6 }
